import { sha256 } from '@app/utils/sha256';

const IdentifierSymbol = Symbol('IdentifierSymbol');
export type LocationIdentifier = {
    value: string;
    [IdentifierSymbol]: never;
};

const state: State = {
    identifier: null,
};

export const locationObservability = {
    setIdentifier: setIdentifierFactory(localStorage, state),
    getIdentifier: getIdentifierFactory(localStorage, state),
    setIdentifierFactory,
    getIdentifierFactory,
};

function setIdentifierFactory(storage: Storage, state: State): (username: string, playerId: string) => Promise<void> {
    return async function setIdentifier(username: string, playerId: string): Promise<void> {
        storage.setItem(await getIdentifierCacheKey(username), playerId);
        state.identifier = {
            value: playerId,
        } as LocationIdentifier;
    };
}

function getIdentifierFactory(storage: Storage, state: State): (username: string) => Promise<LocationIdentifier> {
    return async function getIdentifier(username: string): Promise<LocationIdentifier> {
        const hashedUsername = await hashIt(username);
        const cacheKey = await getIdentifierCacheKey(username);

        if (!state.identifier) {
            state.identifier = {
                value: storage.getItem(cacheKey) || hashedUsername,
            } as LocationIdentifier;
        }
        return state.identifier;
    };
}

async function getIdentifierCacheKey(username: string): Promise<string> {
    const hashedUsername = await hashIt(username);
    return `geolocs: ${hashedUsername}`;
}

function hashIt(input: string): Promise<string> {
    return sha256(input.toLowerCase());
}

type State = {
    identifier: LocationIdentifier | null;
};
